<p>{{props?.label}} <a (click)="showModal()"><fa-icon [icon]="props?.icon"></fa-icon></a></p>
